import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchModal {

  private isSearchOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  watch(): Observable<boolean> {
    return this.isSearchOpen.asObservable();
  }

  open() {
    this.isSearchOpen.next(true);
  }

  close() {
    this.isSearchOpen.next(false);
  }

}